import { ApolloLink } from 'apollo-link';
import AuthToken from '@/utils/auth-token';
import currentUnitStore from '@/utils/current-unit-store';

export default new ApolloLink((operation, forward) => {
  const token = AuthToken.get();
  operation.setContext({
    headers: {
      Authorization: `Bearer ${token}`,
      'X-CURRENT-UNIT': currentUnitStore.get().toString(),
    },
  });

  return forward(operation).map(response => {
    const context = operation.getContext();
    const { response: { headers } } = context;

    if (headers) {
      const jwt = headers.get('jwt');
      if (jwt) AuthToken.set(jwt);

      const currentUnitId = headers.get('X-CURRENT-UNIT');
      if (currentUnitId) {
        currentUnitStore.set(currentUnitId);
        currentUnitStore.saveToLocalStorage();
      }
    }

    return response;
  });
});
